import React, { useEffect, useState } from "react";
// import cursor from "../Cursor.png";

// Linkedin Post Editor Page Body
export const LPEPageBody = ({ children }) => {
  return (
    <div className="w-full h-full">
      <div className="w-full max-w-[1248px] md:mx-auto">{children}</div>
    </div>
  );
};

export const LPESection = ({
  children,
  title,
  description,
}: {
  children: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
}) => {
  return (
    <div className="w-full py-10 flex flex-col gap-8">
      <div className="flex flex-col text-center items-center justify-center">
        <h2 className="text-center font-[Inter] text-3xl px-4 md:text-[34px] not-italic font-bold leading-[normal]">
          {title}
        </h2>
        {description && (
          <p className="text-[#919191] text-center font-[Inter] not-italic font-normal leading-[28px] md:w-1/2">
            {description}
          </p>
        )}
      </div>
      <div className="flex items-center justify-center p-5">{children}</div>
    </div>
  );
};

export const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX + 10, y: e.clientY + 10 });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      className="fixed pointer-events-none z-50"
      style={{
        left: position.x,
        top: position.y,
        transform: "translate(-50%, -50%)",
      }}
    >
      <img src={"cursor"} alt="Custom Cursor" className="size-5" />
    </div>
  );
};
